import { createStyles, Theme } from '@mui/material'

const styles = ({ spacing }: Theme) =>
  createStyles({
    loadingContainer: {
      position: 'absolute',
      width: '100%',
      height: `calc(100% - ${spacing(12)}px)`,
      bottom: 0,
      left: 0,
      zIndex: 99,
      background: 'rgba(255,255,255,0.9)',
    },
  })

export default styles
